import type { Metric } from '@/shared/generated'

import { useMetricsQuery } from '@/entities/bi'

import { MetricMeasure } from '@/shared/generated'
import { formatMoney, formatNumber, NumberFormats } from '@/shared/tools/locale'

// used until the metrics schema is loaded
const FALLBACK_MONEY_METRICS = ['revenue', 'gross_profit']

export const getMoneyMetricNames = (
	metrics?: Pick<Metric, 'name' | 'measure'>[] | null
) =>
	metrics?.length
		? metrics
				.filter((m) => m.measure === MetricMeasure.Money)
				.map((m) => m.name)
		: FALLBACK_MONEY_METRICS

/** Names of money metrics from the metrics schema (shares the cached metrics query). */
export const useMoneyMetrics = () =>
	useMetricsQuery<string[]>({ select: getMoneyMetricNames }).data ??
	FALLBACK_MONEY_METRICS

export const isMoneyMetric = (
	metric: string | undefined,
	moneyMetrics: string[] = FALLBACK_MONEY_METRICS
) => !!metric && moneyMetrics.includes(metric)

/** Money sign only for money metrics, plain number otherwise. */
export const formatMetricValue = (
	value: number,
	metric: string | undefined,
	currency: string | undefined,
	moneyMetrics: string[],
	format: NumberFormats = NumberFormats.Compact
) =>
	isMoneyMetric(metric, moneyMetrics)
		? formatMoney(value, currency, format)
		: formatNumber(value, format)
